import { render, staticRenderFns } from "./Scopul.vue?vue&type=template&id=5c016d1f&scoped=true&"
import script from "./Scopul.vue?vue&type=script&lang=js&"
export * from "./Scopul.vue?vue&type=script&lang=js&"
import style0 from "./Scopul.vue?vue&type=style&index=0&id=5c016d1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c016d1f",
  null
  
)

export default component.exports